export const QUILL_THEME = 'snow' as const;

export const QUILL_HISTORY = {
    delay: 2000,
    maxStack: 500,
    userOnly: true
};

export const QUILL_TOOLBARS = {
    contentEditor: [
        ['url'],
        ['bold', 'italic', 'underline', 'strike'],
        [{ 'color': [] }, { 'background': [] }],
        [{ 'align': [] }],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        ['clean']
    ]
};

/** Root-level config for QuillModule.forRoot() — sets the default for all editors. */
export const QUILL_ROOT_CONFIG = {
    modules: {
        history: QUILL_HISTORY,
        toolbar: QUILL_TOOLBARS.contentEditor
    },
    theme: QUILL_THEME
};

/** Per-component modules config passed via [modules] on <quill-editor>. */
export const QUILL_COMPONENT_CONFIGS = {
    contentEditor: {
        toolbar: QUILL_TOOLBARS.contentEditor
    }
};
